import clsx from "clsx";
import { Form, InputGroup } from "react-bootstrap";
import { React, useState } from "react";
import _ from "lodash";
import { useForm} from "react-hook-form";
import * as axiosInstance from "../../../../services/axiosInstance";
import PAGE from "../../../../utils/Destination";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";
import * as withdrawActions from "../../../../action/withdraw";



const CashWithdrawalDetail = ({
  data,
  page,
  setPage,
  onClickViewPayment,
  statusOptions,
  onChangeStatus,
  statusFilter,
  onChangeDateFrom,
  dateTo,
  dateFrom,
  onChangeDateTo,
  withdrawData,
    clientCode,
    bankAccount,
    totalAmount
}) => {

  // const datalisting = _.get(data, ["data", "data"], []);
  // const loading = _.get(data, ["isLoading"], false);
  // const lastPage = _.get(data, ["data", "meta", "last_page"], null);
  // const onClickView = (values, id) => {
  //     onClickViewPayment(values, id);
  // };
  const date = new Date();
  const dateNow = date.toISOString().split("T")[0];
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();

  const handleGoBack = (e) => {
    e.preventDefault();
    history.goBack();
  };

  const bankName = _.get(withdrawData, ["attributes", "esp", "esp_bank_name"], []);
  const postData = _.get(withdrawData, ["items"], []);
  const currenyText = _.get(withdrawData, ["currency", "text"], []);
  const onSubmit = async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.post("clientarea/withdraw", {
        withdraw_amount: totalAmount,
        items: _.map(postData,item=>{
          return {...item,amount:Math.abs(_.get(item,['amount']))}
        }),
      });
      if (response.code === 200) {
        dispatch(withdrawActions.setWithdrawData({ withdraw_amount: totalAmount, items: postData }));
        history.push(PAGE.WITHDRAW_TRANSACTION);
      }
    } catch (e) {
      console.log("ee" + e);
    } finally {
      setIsLoading(false);
    }
  };



  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    watch,
  } = useForm({ defaultValues: { date_now: dateNow, client_code: clientCode, bank_name:bankName, bank_account: bankAccount, total_amount: totalAmount } });
  const formattedAmount = parseFloat(watch("total_amount") || 0).toFixed(2);

  return (
    <div className=" mt-4 py-3 d-flex justify-content-center">
      <Form className="mt-3 w-100" onSubmit={handleSubmit(onSubmit)} style={{ maxWidth: "700px" }}>
        <div className="fpx-transfer-content-input padding-12px my-2">
          <p className="fpx-transfer-content-inner-label">Request Date</p>
          <Form.Group className="w-100">
            <Form.Control type="text" {...register("date_now")} disabled />
          </Form.Group>
        </div>

        <div className="fpx-transfer-content-input padding-12px my-2">
          <p className="fpx-transfer-content-inner-label">Client Code </p>
          <Form.Group className="w-100">
            <Form.Control type="text" {...register("client_code")} disabled />
          </Form.Group>
        </div>

        {/*<div className="fpx-transfer-content-input padding-12px my-2">*/}
        {/*  <p className="fpx-transfer-content-inner-label">Withdrawal Type</p>*/}
        {/*  <Form.Group className="w-100">*/}
        {/*    <Form.Control name="client_remark" type="text" {...register("client_remarks")} disabled/>*/}
        {/*  </Form.Group>*/}
        {/*</div>*/}

        <div className="fpx-transfer-content-input padding-12px my-2">
          <p className="fpx-transfer-content-inner-label">Bank Account no</p>
          <Form.Group className="w-100">
            <Form.Control name="client_remark" type="text" {...register("bank_account")} disabled/>
          </Form.Group>
        </div>

        <div className="fpx-transfer-content-input padding-12px my-2">
          <p className="fpx-transfer-content-inner-label">Bank to be deposited</p>
          <Form.Group className="w-100">
            <Form.Control name="client_remark" type="text" {...register("bank_name")} disabled/>
          </Form.Group>
        </div>

        <div className="fpx-transfer-content-input padding-12px my-2">
          <p className="fpx-transfer-content-inner-label">Withdrawal Amount</p>
          <Form.Group className="w-100">
            <InputGroup>
              <InputGroup.Text style={{ borderRadius: '2px' }}>{currenyText}</InputGroup.Text>
              <Form.Control name="total_amount" type="text" value={formattedAmount} {...register("total_amount")} disabled/>
            </InputGroup>
          </Form.Group>
        </div>

        <div className="d-flex justify-content-center py-3">
          <button className={clsx("btn custom-button-back")} onClick={handleGoBack}>Back</button>
          <button
            className={clsx("btn custom-button-primary")}
            type="submit"
            style={{ backgroundColor: "#9D7905" }}
            // disabled={_.isEmpty(watch('bank_id'))}
          >
            Proceed
          </button>
        </div>
      </Form>
    </div>
  );
};

export default CashWithdrawalDetail;
